"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immer_1 = require("immer");
const getTeacherFeedbackRemovedEvent_1 = require("../helpers/getEvent/getTeacherFeedbackRemovedEvent");
const getInteractionKey_1 = require("../helpers/getInteraction/getInteractionKey");
const getState_1 = require("../helpers/getState");
const getStateInteraction_1 = require("../helpers/getStateInteraction");
const entity_1 = require("../type/entity");
function applyRemoveTeacherFeedbackCommand(command, user, states, stateInteractions) {
    const { cardQuestionId, creatorId: teacherId, timeStamp, rootContentId } = command;
    const events = [];
    const cardQuestionState = getState_1.getStateByContentIdUserId(states, cardQuestionId, user.userId);
    const submissionId = cardQuestionState.submissions[0]._id;
    const updatedStateInteractions = immer_1.produce(stateInteractions, draftStateInteractions => {
        const interactionKeyForLearner = getInteractionKey_1.getInteractionKeyForLearner(cardQuestionId, entity_1.InteractionType.Feedback, submissionId, teacherId);
        const stateInteraction = getStateInteraction_1.getStateInteractionByInteractionKeyForLearner(draftStateInteractions, interactionKeyForLearner);
        if (!stateInteraction) {
            throw new Error('no feedback found');
        }
        stateInteraction.deleted = true;
        stateInteraction.updatedAt = timeStamp;
        const teacherFeedbackRemoved = getTeacherFeedbackRemovedEvent_1.getTeacherFeedbackRemovedEvent(command, user, rootContentId, entity_1.ContentType.CARD_QUESTION, submissionId);
        events.push(teacherFeedbackRemoved);
    });
    return { states: [], events, stateInteractions: updatedStateInteractions, enrolments: [] };
}
exports.applyRemoveTeacherFeedbackCommand = applyRemoveTeacherFeedbackCommand;
//# sourceMappingURL=applyRemoveTeacherFeedbackCommand.js.map